module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex bg-white br3 new-shadow-theme mr5 custom-padding responsive-box"
  }, [_c('div', {
    staticClass: "flex flex-column w-100 responsive-plan"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb3 fw5"
  }, [_vm._v("Choose Your Plan")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row flex-wrap w-100 justify-between cards mv2"
  }, [_c('plan-select-toggle-vue', {
    attrs: {
      "isPhoneOnly": _vm.isPhoneOnly,
      "setValue": _vm.setValue,
      "setAkkoPlan": _vm.setAkkoPlan,
      "setPhonePlan": _vm.setPhonePlan
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cera-round-pro mv3"
  }, [_vm._v("Protect 1 phone per plan")]), _vm._v(" "), _c('div', {
    staticClass: "f5 fw gray mt2 flex"
  }, [_c('div', {
    staticClass: "flex flex-wrap gradual-width"
  }, _vm._l((_vm.planInfo), function(info, index) {
    return _c('select-plan-icon-with-text', {
      key: index,
      attrs: {
        "divClass": "mv2 mr2 plan-be inter",
        "text": info,
        "svg": "/static/appicons/Check.svg",
        "svgStyle": "margin-top: -1px"
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "vertical-bar mr3"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-around"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f3"
  }, [_vm._v(_vm._s(_vm.planValues) + " "), _c('span', {
    staticClass: "inter f5"
  }, [_vm._v("Per Month")])]), _vm._v(" "), _c('div', {
    staticClass: "inter"
  }, [_vm._v("$29 - $99 deductibles")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6758f38c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/selectBox/SelectPlan.vue
// module id = 768
// module chunks = 0